import { render, staticRenderFns } from "./CollectForm.vue?vue&type=template&id=7fffd93a&"
import script from "./CollectForm.vue?vue&type=script&lang=js&"
export * from "./CollectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports